import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PaymentApiService } from "src/app/api/payment-api.service";
import { GymBranch } from "src/app/types/gym-branch.type";

@Component({
  selector: "app-gym-branch-selection-card",
  templateUrl: "./gym-branch-selection-card.component.html",
  styleUrls: ["./gym-branch-selection-card.component.scss"],
  standalone: false,
})
export class GymBranchSelectionCardComponent {
  constructor(private paymentApi: PaymentApiService) {}
  branches: GymBranch[] = [];
  @Input() selectedBranchId: string | null = null;

  @Output() branchSelected = new EventEmitter<string>();
  @Output() subscriptionExpiryDate = new EventEmitter<Date>();

  async ngOnInit() {
    try {
      const response = await this.paymentApi.getGymBranches();
      this.branches = response.data;

      // Auto-select first branch if no branch is selected
      if (!this.selectedBranchId && this.branches.length > 0) {
        this.selectedBranchId = this.branches[0]._id;
        this.subscriptionExpiryDate.emit(
          this.branches[0].subscriptionExpiryDate
        );
      } else if (this.selectedBranchId) {
        // If branch is pre-selected (e.g., from URL subID), find and emit its expiry date
        const selectedBranch = this.branches.find(
          (branch) => branch._id === this.selectedBranchId
        );
        if (selectedBranch?.subscriptionExpiryDate) {
          this.subscriptionExpiryDate.emit(selectedBranch.subscriptionExpiryDate);
        }
      }

      this.branchSelected.emit(this.selectedBranchId);
    } catch (error) {
      console.error("Error fetching gym branches:", error);
    }
  }

  onBranchSelect(branchId: string): void {
    this.selectedBranchId = branchId;
    this.branchSelected.emit(branchId);

    // get subscription expiry date
    const subscriptionExpiryDate = this.branches.find(
      (branch) => branch._id === branchId
    )?.subscriptionExpiryDate;
    this.subscriptionExpiryDate.emit(subscriptionExpiryDate);
  }
}
